import React from 'react'
import '../Styles/slide_auto.css'
import ItemPartner from './ItemPartner';
import logoStar from '../Assets/partners/logo-star-white.webp'
import logoVolar from '../Assets/partners/logo-volar.webp'
import logoCris from '../Assets/partners/logo-criszuca.webp'
import logoBarbearia from '../Assets/partners/logo-barbearia.webp'
import logoCamarote from '../Assets/partners/logo-camarote.webp'
import logoCarRental from '../Assets/partners/logo-carrental.webp'
import logoCartao from '../Assets/partners/logo-cartaoaltarenda.webp'
import logoCelebrations from '../Assets/partners/logo-celebration.webp'
import logoHotel from '../Assets/partners/logo-hotelmonreale.webp'
import logoNaturativa from '../Assets/partners/logo-naturativa.webp'
import logoMeuChip from '../Assets/partners/logo-omeuchip.webp'
import logoR3 from '../Assets/partners/logo-r3car.webp'


function Slider() {
return (
    <div className="slider" style={{ '--width': '130px', '--height': '50px', '--quantity': '13' }}>
        <div className="list">
            <ItemPartner position="1" srcLogo={logoStar} altLogo="Star Agency"/>
            <ItemPartner position="2" srcLogo={logoVolar} altLogo="Volar"/>
            <ItemPartner position="3" srcLogo={logoCris} altLogo="Cris Zuca"/>
            <ItemPartner position="4" srcLogo={logoBarbearia} altLogo="Barberia do Zé"/>
            <ItemPartner position="5" srcLogo={logoCamarote} altLogo="Camarote Lounge Carioca"/>
            <ItemPartner id="crs-logo" position="6" srcLogo={logoCarRental} altLogo="Car Rental Solutions"/>
            <ItemPartner position="7" srcLogo={logoCartao} altLogo="Cartão de Alta Renda"/>
            <ItemPartner position="8" srcLogo={logoCelebrations} altLogo="Celebrations Suites"/>
            <ItemPartner position="9" srcLogo={logoHotel} altLogo="Hotel Monreale Express"/>
            <ItemPartner position="10" srcLogo={logoNaturativa} altLogo="Naturativa - Farmácia de Manipulação"/>
            <ItemPartner position="11" srcLogo={logoMeuChip} altLogo="O Meu Chip"/>
            <ItemPartner position="12" srcLogo={logoR3} altLogo="R3 Rentalcar"/>
        </div>
    </div>
);
}
  
  export default Slider;
